module.exports = __webpack_public_path__ + "static/media/7.ce8f7d9e.jpg";